module.exports = __webpack_public_path__ + "img/gradient-triangle.7642fab9.svg";